import { c as r } from "./classof.js";
var a = function a(_a) {
  var i = r(_a);
  return "BigInt64Array" == i || "BigUint64Array" == i;
};
export { a as i };